import React, {useEffect, useState} from "react";
import {Line} from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Filler
} from 'chart.js';
import SubHeader from "../../components/WithSubHeaderBG";
import {Box, Text} from "../../designSystem";
import DropDownSelect from "../../components/GenericDropDownSelect";
import {get, post} from "../../lib/api";
import InfoIconWithTooltip from "../../components/InfoIconWithTooltip";
import Loader from "../../components/Loader";

ChartJS.register(CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Filler);

const RevenueUI = (props) => {
  const [bookList, setBookList] = useState([])
  const [bookSelected, updateBookSelected] = useState('');
  const [monthSelected, updateMonthSelected] = useState('');
  const [monthList, updateMonthList] = useState([]);
  const [loaderOne, updateLoaderOne] = useState(true);
  const [loaderTwo, updateLoaderTwo] = useState(false);
  const [bookStatistics, updateBookStatistics] = useState({
    perfomance_based_revenue: '-',
    currency: "INR",
    data: [],
    lineData: {},
    info: "",
    message: ""
  });

  const fetchBooks = () => {
    get('/content_api/book.cbp_book_list?is_novel=1').then(response => {
      if (response.length < 1) {
        props.history.push('/home');
        return;
      }
      setBookList(response);
      updateBookSelected(response[0].book_id);
      updateLoaderOne(false);
    })
  }
  const fetchBookStatistics = () => {
    if (bookSelected.length < 1) return;
    updateLoaderTwo(true);
    get('/user_api/novel_revenue', {
      params: {
        book_id: bookSelected,
        is_novel: 1,
      }
    })
      .then(response => {
        updateLoaderTwo(false);
        if (response.currency === "USD") {
          response.perfomance_based_revenue = "$ " + response.perfomance_based_revenue;
        } else {
          response.perfomance_based_revenue = "₹ " + response.perfomance_based_revenue;
        }
        if (response.data.length > 0) {
          response.lineData = {
            labels: response.data.map(data => data.date),
            datasets: [{
              label: `Revenue (${response.perfomance_based_revenue.substring(0, 1)}) `,
              data: response.data.map(data => Number(data.value.toFixed(2))),
              fill: true,
              backgroundColor: 'rgba(125,197,245,0.67)',
              borderColor: 'rgb(54,95,122)',
            }]
          }
        }
        updateBookStatistics(response);
      });
  }
  useEffect(() => {
    if (!props.user.revenue_tab) {
      props.history.push('/home');
      return;
    }
    fetchBooks();
    updateMonthList([{
      "name": "Lifetime",
      "id": "lifetime"
    }]);
  }, []);

  useEffect(() => {
    fetchBookStatistics();
  }, [bookSelected])

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    hoverRadius: 8,
  };
  return (
    <SubHeader title="Revenue">
      <Box variant="flexCard" p={[16, 24]} borderTopLeftRadius="4px" borderTopRightRadius="4px">
        <Text variant="heading">
          Revenue Dashboard
        </Text>
      </Box>
      <Box variant="hr"/>
      {
        loaderOne ? <Loader/> :
          bookList?.length > 0 && (
            <>
              <Box variant="flex" backgroundColor="surface.foreground" mt="8px" mb="8px" py={16} px={8}>
                <Box width={["50vw", "40%"]}>
                  <DropDownSelect
                    name="book"
                    placeholder="Name of the novel"
                    selectOptions={bookList.filter((book) => !book.is_disabled)}
                    idKey="book_id"
                    nameKey="book_title"
                    value={bookSelected}
                    clickOnSelect
                    onChange={bookID => updateBookSelected(bookID)}
                  />
                </Box>
                <Box width={["50vw", "30%"]}>
                  <DropDownSelect
                    name="interval"
                    placeholder="Lifetime"
                    selectOptions={monthList}
                    idKey="id"
                    nameKey="name"
                    value={monthSelected}
                    filterIcon
                    clickOnSelect
                    onChange={month => updateMonthSelected(month)}
                  />
                </Box>
              </Box>
              <Box backgroundColor="surface.foreground" mb="8px" mt="8px" py={16}
                   px={16} width={"100%"} borderRadius="9px">
                <InfoIconWithTooltip
                  tooltipTitle="Revenue shared with the author based on performance of the book."
                  toolTipType="popUp" top="4px"
                  position="absolute"/>
                <Text ml="25px" mb="16px"
                      variant="title">Performance Based Revenue</Text>
                <Text ml="25px" variant='titleMedium'>
                  {bookStatistics.perfomance_based_revenue}
                </Text>
              </Box>
              {bookStatistics?.info && <Box backgroundColor="rgba(242, 198, 2, 0.08)" mt="16px" mb="16px" py={16}
                                            px={8}>
                <Text height="34px" textAlign="center" variant="" color="#ae8701">
                  <strong>{bookStatistics?.info}</strong>
                </Text>
              </Box>}
              {
                bookStatistics.message && <Box backgroundColor="rgba(242, 198, 2, 0.08)" mt="16px" mb="16px" py={16}
                                               px={8}>
                  <Text height="34px" textAlign="center" variant="" color="#ae8701">
                    <strong>{bookStatistics.message}</strong>
                  </Text>
                </Box>
              }
              {
                loaderTwo ? <Loader/> :
                  <>
                    {bookStatistics?.data.length > 0 &&
                      <Box backgroundColor="white" px="20px" pt="15px" pb="40px" height="330px">
                        <Text paddingLeft="6px" paddingBottom="10px" variant="heading">Performance Based Bonus By
                          Time</Text>
                        <Line
                          datasetIdKey='id'
                          data={bookStatistics.lineData}
                          options={options}
                        />
                      </Box>
                    }
                  </>
              }

            </>
          )
      }
    </SubHeader>
  )
}

export default RevenueUI;